import { Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MuiSlider from "../slider/MuiSlider";
import styles from "./VideoPlayer.module.css";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import VolumeOffRoundedIcon from "@mui/icons-material/VolumeOffRounded";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import getVideoDuration from "../../../utils/video-duration-formatter/VideoDuration";

const VideoPlayer = (props: any) => {
  const {
    isThumbnail,
    videoUrl,
    data,
    index,
    audioRefs,
    handlePlayPause,
    handleUnMute,
    handleMute,
    handlePauseWhenAudioEnded,
  } = props

  const intervalRef: any = useRef();

  const [totalVideoDuration, setTotalVideoDuration] = useState(0);
  const [currentPlayTime, setCurrentPlayTime] = useState(0);
  const [trackProgress, setTrackProgress] = useState(0);

  useEffect(() => {
    setTotalVideoDuration(audioRefs?.current[index]?.duration);
    const timer = setTimeout(() => {
      setTotalVideoDuration(
        audioRefs?.current[index]?.duration == Number.NaN
          ? 0
          : audioRefs?.current[index]?.duration
      );
    }, 2000);
    return () => {
      clearTimeout(timer);
      clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (data?.isPlaying) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCurrentPlayTime(audioRefs?.current[index]?.currentTime);
        setTrackProgress(audioRefs?.current[index]?.currentTime);
      }, 1000);
    }
  }, [data?.isPlaying]);

  useEffect(() => {
    if (audioRefs.current[index]?.ended) {
      handlePauseWhenAudioEnded(index, data)
      setTotalVideoDuration(audioRefs.current[index].duration);
    }
  }, [audioRefs?.current[index]?.ended]);

  const handleSliderChange = (value: Event) => {
    audioRefs.current[index].currentTime = value;
    setTrackProgress(audioRefs?.current[index]?.currentTime);
  };

  return (
    <div className={styles["video-container"]}>
      <video
        // autoPlay={true}
        ref={(el) => (audioRefs.current[index] = el)}
        muted={data?.isMute}
        className={styles["video"]}
        src={videoUrl}
        id={`${videoUrl}+${index}+${data.id}`}
        style={{
          objectFit: props.objectFit ? props.objectFit : "cover"
        }}
      ></video>
      {/* <div className={styles["controls-container"]}>

      </div> */}
      <div
        className={
          isThumbnail ? styles["thumbnail-controls"] : styles["video-controls"]
        }
      >
        <div>
          {isThumbnail ? (
            <PlayCircleOutlineRoundedIcon
              className={styles["thumbnail-icon"]}
            />
          ) : data?.isPlaying ? (
            <PauseCircleOutlineRoundedIcon
              className={styles["pause-icon"]}
              onClick={(e) => {
                e.stopPropagation()
                handlePlayPause(index, data)
              }}
            />
          ) : (
            <PlayCircleOutlineRoundedIcon
              className={styles["play-pause-icon"]}
              onClick={(e) => {
                e.stopPropagation()
                handlePlayPause(index, data)
              }}
            />
          )}
        </div>
        <div className={styles["mute-container"]}>
          {data?.isMute ? (
            <VolumeOffRoundedIcon
              onClick={(e) => {
                e.stopPropagation()
                handleUnMute(index, data)
              }}
              className={styles["mute-icon"]}
            />
          ) : (
            <VolumeUpRoundedIcon
              onClick={(e) => {
                e.stopPropagation()
                handleMute(index, data)
              }}
              className={styles["mute-icon"]}
            />
          )}
        </div>
        {/* <Stack
          style={{ width: "90%" }}
          spacing={2}
          alignItems={"center"}
          textAlign={"center"}
          justifySelf={"right"}
        >
          {data?.isMute ? (
            <VolumeOffRoundedIcon
              onClick={(e) => {
                e.stopPropagation()
                handleUnMute(index, data)
              }}
              className={styles["mute-icon"]}
            />
          ) : (
            <VolumeUpRoundedIcon
              onClick={(e) => {
                e.stopPropagation()
                handleMute(index, data)
              }}
              className={styles["mute-icon"]}
            />
          )}
          <Typography className={styles["video-play-time"]}>
            {getVideoDuration(currentPlayTime)}
          </Typography>
          <MuiSlider
            trackProgress={trackProgress}
            duration={totalVideoDuration}
            handleSliderChange={handleSliderChange}
          />
          <Typography className={styles["video-play-time"]}>
            {getVideoDuration(totalVideoDuration)}
          </Typography>
        </Stack> */}
      </div>
    </div>
  );
};

export default VideoPlayer;
